import React, { useEffect, useContext, useState } from 'react'
import { Helmet } from 'react-helmet'

import { APIContext } from '../../../context/APIContext'
import { getEnvironment } from '../../../utils/appUtils'

const CookieBanner = () => {
  const apiContext = useContext(APIContext)

  const [template, setTemplate] = useState('')

  const [api] = useState({
    zdCookie: apiContext[getEnvironment('ZD_COOKIE_URL') || ''],
    tracking: apiContext[getEnvironment('ZD_COOKIE_TRACKING') || ''],
  })

  // Lazy load template at first
  useEffect(() => {
    async function loadTemplate() {
      const { htmlTemplate } = await import('@aok/cookie-settings-manager/build/cjs/index')
      setTemplate(htmlTemplate)
    }
    loadTemplate()
  }, [])

  // Secondly load Cookie layer
  // Need to lazy load cookie layer because of global window and document defined in the cookie manager itself
  useEffect(() => {
    async function loadCookieManager() {
      const { CookieSettingsManager } = await import('@aok/cookie-settings-manager/build/cjs/index')
      window.CookieSettingsManager = new CookieSettingsManager({
        server: {
          url: api.zdCookie,
          trackingUrl: api.tracking,
          portal: 'pk',
        },
      })
    }
    if (template) {
      loadCookieManager()
    }
  }, [template, api])

  return (
    <Helmet>
      <script id="cookie-dialog-template" type="text/template">
        {template}
      </script>
    </Helmet>
  )
}

export default CookieBanner
